import React from 'react';
import Service from './Service';
import { serviceData } from './serviceData';
import './services.scss';

const Services = () => {
  return (
    <section className="services section" id="services">
      <h2 className="section__title">Services</h2>
      <span className="section__subtitle">What I Offer</span>

      <div className="services__container container grid">
        {serviceData.map((service) => {
          return <Service service={service} key={service.id} />;
        })}
      </div>
    </section>
  );
};

export default Services;
